<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Daily Full Load Report</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-btn color="error" style="width:50px"></v-btn>
                        <h3 style="margin-top:10px;margin-left:10px">Detention Charge</h3>
                        <v-btn color="success" style="margin-left:20px;width:50px"></v-btn>
                        <h3 style="margin-top:10px;margin-left:10px">Free Days Remaining</h3>
                      </v-layout>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                    style="width:1200px"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.containerno }}</td>
                      <td class="text-xs-left">{{ props.item.containertype}}</td>
                      <td class="text-xs-left">{{ props.item.containercurrentlocation}}</td>
                      <td class="text-xs-left">{{ props.item.containerliftingdate}}</td>
                      <td class="text-xs-left">{{ props.item.containerrdeliverysite}}</td>
                      <td class="text-xs-left">{{ props.item.containerdeliverydate}}</td>
                      <td class="text-xs-left">{{ props.item.containerstuffingdate}}</td>
                      <td class="text-xs-left">{{ props.item.containergateindate}}</td>
                      <td class="text-xs-left">{{ props.item.containershippedonboarddate}}</td>
                      <td class="text-xs-left"><b style="color:green">{{ props.item.daysremainingfree}}</b> / 21</td>
                      <td class="text-xs-left">{{ props.item.chargetype}}</td>
                    </template>
                  </v-data-table>
                  <v-layout row wrap style="margin-top:20px;text-align: left">
                    <v-flex xs3>
                      <p><b>Sales Order No:</b> 986532147</p>
                      <p><b>Sales Booking No:</b> 986536987</p>
                      <p><b>Voyage:</b> 1234</p>
                    </v-flex>
                    <v-flex xs3>
                      <p><b>Port of Landing:</b> Dammam Saudi Arabis</p>
                      <p><b>AME Booking No:</b> AME / FF / 12547</p>
                      <p><b>Vessel:</b> AME / FF / 12547</p>
                    </v-flex>
                    <v-flex xs3>
                      <p><b>Shipping Line:</b> MAERSK LINE</p>
                      <p><b>Port of Discharge:</b> Sudan</p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Container No', value: 'containerno' },
        { text: 'Container Type', value: 'containertype' },
        { text: 'Container Current Location', value: 'containercurrentlocation' },
        { text: 'Container Lifting Date', value: 'containerliftingdate' },
        { text: 'Container Delivery Site', value: 'containerrdeliverysite' },
        { text: 'Container Delivery Date', value: 'containerdeliverydate' },
        { text: 'Container Stuffing Date', value: 'containerstuffingdate' },
        { text: 'Container Gate In Date', value: 'containergateindate' },
        { text: 'Container Shipped on Board Date', value: 'containershippedonboarddate' },
        { text: 'Days Remaining / Free', value: 'daysremainingfree' },
        { text: 'Charge Type', value: 'chargetype' }
      ],
      desserts: [
        {
          no: '1',
          containerno: 'MSKU123654',
          containertype: '20` Dry Standard',
          containercurrentlocation: 'Dammam Terminal',
          containerliftingdate: '02 Aug 2017',
          containerrdeliverysite: 'Dammam Warehouse',
          containerdeliverydate: '02 Aug 2017',
          containerstuffingdate: '02 Aug 2017',
          containergateindate: '02 Aug 2017',
          containershippedonboarddate: '04 Aug 2017',
          daysremainingfree: '20',
          chargetype: 'Detention'
        },
        {
          no: '2',
          containerno: 'MSKU123654',
          containertype: '20` Dry Standard',
          containercurrentlocation: 'Dammam Terminal',
          containerliftingdate: '02 Aug 2017',
          containerrdeliverysite: 'Dammam Warehouse',
          containerdeliverydate: '02 Aug 2017',
          containerstuffingdate: '02 Aug 2017',
          containergateindate: '02 Aug 2017',
          containershippedonboarddate: '04 Aug 2017',
          daysremainingfree: '02',
          chargetype: 'Detention'
        },
        {
          no: '3',
          containerno: 'MSKU123654',
          containertype: '20` Dry Standard',
          containercurrentlocation: 'Dammam Terminal',
          containerliftingdate: '02 Aug 2017',
          containerrdeliverysite: 'Dammam Warehouse',
          containerdeliverydate: '02 Aug 2017',
          containerstuffingdate: '02 Aug 2017',
          containergateindate: '02 Aug 2017',
          containershippedonboarddate: '04 Aug 2017',
          daysremainingfree: '10',
          chargetype: 'Detention'
        }
      ],
      show1: true,
      show2: false,
      show3: false
    }
  },
  mounted () {
    console.log('wynumtrack page')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Dailyfullloadreport.vue